import React from 'react';
import { useTheme, alpha } from '@mui/material';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid,
    Tooltip, Legend, ResponsiveContainer, Cell,
} from 'recharts';
import {
    ThumbUp as ThumbUpIcon,
    TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';
import ChartCard from './ChartCard';
import CustomTooltip from './CustomTooltip';

export const LikesCommentsChart = ({ chartData, height = 340 }) => {
    const theme = useTheme();
    const axisStyle = { stroke: theme.palette.text.secondary, fontSize: 12 };

    return (
        <ChartCard
            title="Likes & Comments by Platform"
            icon={<ThumbUpIcon />}
            height={height}
        >
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 5 }} barSize={16}>
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke={alpha(theme.palette.divider, 0.4)}
                        vertical={false}
                    />
                    <XAxis
                        dataKey="platform"
                        {...axisStyle}
                        axisLine={false}
                        tickLine={false}
                        dy={10}
                    />
                    <YAxis
                        {...axisStyle}
                        axisLine={false}
                        tickLine={false}
                        dx={-10}
                    />
                    <Tooltip content={<CustomTooltip />} cursor={{ fill: 'transparent' }} />
                    <Legend wrapperStyle={{ paddingTop: '10px' }} />
                    <Bar dataKey="likes" name="Likes" fill="#0284c7" radius={[6, 6, 0, 0]} />
                    <Bar dataKey="comments" name="Comments" fill="#0d9488" radius={[6, 6, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </ChartCard>
    );
};

export const EngagementRateChart = ({ chartData, height = 340 }) => {
    const theme = useTheme();
    const axisStyle = { stroke: theme.palette.text.secondary, fontSize: 12 };

    return (
        <ChartCard title="Engagement Rate %" icon={<TrendingUpIcon />} height={height}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={chartData}
                    layout="vertical"
                    margin={{ top: 10, right: 20, left: 10, bottom: 5 }}
                    barSize={16}
                >
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke={alpha(theme.palette.divider, 0.4)}
                        horizontal={true}
                        vertical={false}
                    />
                    <XAxis
                        type="number"
                        {...axisStyle}
                        axisLine={false}
                        tickLine={false}
                        tickFormatter={(v) => `${v}%`}
                        dy={10}
                    />
                    <YAxis
                        type="category"
                        dataKey="platform"
                        {...axisStyle}
                        axisLine={false}
                        tickLine={false}
                        width={70}
                    />
                    <Tooltip
                        contentStyle={{
                            background: theme.palette.background.paper,
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: 12,
                            boxShadow: '0 10px 30px -10px rgba(0,0,0,0.1)',
                            color: theme.palette.text.primary,
                            fontWeight: 600,
                        }}
                        formatter={(value) => [`${value}%`, 'Engagement Rate']}
                        cursor={{ fill: 'transparent' }}
                    />
                    <Bar dataKey="engagement" name="Engagement %" radius={[0, 6, 6, 0]}>
                        {chartData.map((entry, i) => (
                            <Cell key={i} fill={entry.color} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </ChartCard>
    );
};
